import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { HttpService } from "src/app/core/services/http.service";
import { ProjectListService } from "src/app/core/services/project-list/project-list.service";
import { SettingsData, SettingsService } from "src/app/core/services/settings.service";
import { ToastrTranslateService } from "src/app/core/services/toastr-translate.service";

@Component({
  selector: "app-add-media-modal",
  templateUrl: "./add-media-modal.component.html",
  styleUrls: ["./add-media-modal.component.scss"],
})
export class AddMediaModalComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @Input() mediaData: any;
  @Input() showMediaStep: boolean = true;
  @Input() mediaDataforVault: any;
  blockedPanel: boolean = false;
  mediaForm: FormGroup;
  dropdownMediaData: any;
  derivedSettings: any = {};
  projectArr: any = [];
  public mask = [/[0-2]/, /[0-3]/, ":", /[0-5]/, /[0-9]/];
  dropdownAssetData: any = [];
  GLOBAL_COMPANY_ID = 123456789987;
  assetId: any;
  mediaId: any = null;
  barcodeUrl: any;
  public defaultDate: Date = new Date();
  resolutionLabels: any = ["8K", "6K", "5K", "4K", "2K", "1080p", "1080i", "720p", "480p", "360p", "240p", "144p", "SD", "HD", "Full HD", "Ultra HD", "Quad HD", "UHD", "HDR"];
  hideDelete: boolean = false;

  fileExtension: any = null;
  fileName: string = null;

  allowedTypes = ["image/jpeg", "image/png", "image/gif"];
  thumbnailUrl: string | ArrayBuffer = null;
  thumbnailName: string = "";
  addedThumbnailMessage: string = "";
  invalidThumbnailFormatError: string = "";
  allowedExtensionsForThumbnail: string[] = ["jpg", "jpeg", "png"];
  removePhoto: boolean = false;
  mediaDetails: any;

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private settingsService: SettingsService, private httpService: HttpService, private toastr: ToastrTranslateService) {
    this.mediaForm = this.createMediaForm();
    this.derivedSettings = this.settingsService.derivedSettigs;
  }

  ngOnInit(): void {
    this.getMediaDropDownData();
    this.setValidationOnDuration();
    this.assetId = this.mediaData.assetId;
    if (this.mediaData && this.mediaData.id) {
      this.hideDelete = true;
      console.log("this is media data on ngOnInit", this.mediaData);
      this.mediaId = this.mediaData.id;
      this.mediaForm.get("title").setValue(this.mediaData.mediaTitle);
      this.mediaForm.get("umid").setValue(this.mediaData.uMId);
      this.mediaForm.get("version").setValue(this.mediaData.mediaVersion);
      this.mediaForm.get("vaultshelf").setValue(this.mediaData.vaultShelf);
      this.mediaForm.get("vaultmediaid").setValue(this.mediaData.uMId);

      if (this.mediaData.mediaTypeId != undefined) {
        this.mediaForm.get("type").setValue(this.mediaData.mediaTypeId);
      }
      if (this.mediaData.mediaSupportId != undefined) {
        this.mediaForm.get("support").setValue(this.mediaData.mediaSupportId);
        this.mediaForm.get("vaultsupport").setValue(this.mediaData.mediaSupportId);
      }
      if (this.mediaData.formatId != undefined) {
        this.mediaForm.get("format").setValue(this.mediaData.formatId);
      }
      if (this.mediaData.mediaBitrateId != undefined) {
        this.mediaForm.get("bitrate").setValue(this.mediaData.mediaBitrateId);
      }
      if (this.mediaData.status != undefined) {
        this.mediaForm.get("status").setValue(this.mediaData.status);
      }
      if (this.mediaData.sanStatus != undefined) {
        this.mediaForm.get("sanstatus").setValue(this.mediaData.sanStatus);
      }
      if (this.mediaData.language != undefined) {
        this.mediaForm.get("language").setValue(this.mediaData.language);
      }
      if (this.mediaData.personId != undefined) {
        this.mediaForm.get("person").setValue(this.mediaData.personId);
      }
      if (this.mediaData.vaultStatus != undefined) {
        this.mediaForm.get("vaultstatus").setValue(this.mediaData.vaultStatus);
      }
      if (this.mediaData.barcodeId != undefined) {
        this.mediaForm.get("barcode").setValue(this.mediaData.barcodeId);
        this.mediaForm.get("barcodeUId").setValue(this.mediaData.barcodeUId);
        this.barcodeUrl = this.mediaData.barcodeUrl;
      }

      if (this.mediaData.fileType != undefined) {
        this.mediaForm.get("fileType").setValue(this.mediaData.fileType);
      }
      if (this.mediaData.fileUrl != undefined) {
        this.mediaForm.get("fileUrl").setValue(this.mediaData.fileUrl);
      }
      if (this.mediaData.resolution != undefined) {
        this.mediaForm.get("resolution").setValue(this.mediaData.resolution);
      }
      if (this.mediaData.aspectRatio != undefined) {
        this.mediaForm.get("aspectRatio").setValue(this.mediaData.aspectRatio);
      }
      if (this.mediaData.frameRate != undefined) {
        this.mediaForm.get("frameRate").setValue(this.mediaData.frameRate);
      }
      if (this.mediaData.duration != undefined) {
        this.mediaForm.get("duration").setValue(this.mediaData.duration);
      }
      if (this.mediaData.colorSpace != undefined) {
        this.mediaForm.get("colorSpace").setValue(this.mediaData.colorSpace);
      }
      if (this.mediaData.date) {
        const parsedDate = new Date(this.mediaData.date);
        this.mediaForm.get("date").setValue(parsedDate);
      }

      if (this.mediaData.audio != undefined) {
        this.mediaForm.get("audio").setValue(this.mediaData.audio);
      }

      // Initialize thumbnailUrl
      if (this.mediaData.thumbnailUrl) {
        this.thumbnailUrl = this.mediaData.thumbnail.url;
      }
    }
  }

  getBarCodeByType() {
    let body = {
      barcodeId: this.mediaForm.get("barcode").value || null,
      barcodeUId: this.mediaForm.get("barcodeUId").value || null,
      url: this.barcodeUrl || null,
    };

    this.httpService.callApi("getMediaBarcodeByType", { body: body }).subscribe(
      (response) => {
        this.mediaForm.get("barcode").setValue(response.barcodeId);
        this.mediaForm.get("barcodeUId").setValue(response.barcodeUId);
        this.barcodeUrl = response.url;
      },
      (error) => {
        this.mediaForm.get("barcode").setValue(null);
        this.mediaForm.get("barcodeUId").setValue(null);
        this.barcodeUrl = null;
      }
    );
  }

  isInArray(arr: string[], val: string): boolean {
    return arr.indexOf(val) !== -1;
  }

  getMediaDropDownData() {
    this.httpService.callApi("getMediaDropDownData", {}).subscribe(
      (response) => {
        this.dropdownMediaData = response;
      },
      (error) => {
        this.toastr.warning(error.error.message, "Asset");
      }
    );
  }

  hideAssetModal() {
    this.closeModalEvent.emit(false);
  }

  createMediaForm() {
    return this.formBuilder.group({
      title: [null, Validators.required],
      umid: [null, [Validators.pattern(/^UMID\d{4}$/)]],
      type: [null],
      support: [null],
      format: [null],
      bitrate: [null],
      status: [null],
      sanstatus: [null],
      language: [null],
      version: [null],
      person: [null],

      date: [new Date(this.defaultDate.getFullYear(), this.defaultDate.getMonth(), 1)],

      duration: [null],
      vaultshelf: [null],
      vaultstatus: [null],
      vaultsupport: [null],
      vaultmediaid: [null],
      barcode: [null],
      barcodeUId: [null],
      avatar: [null],
      fileType: [null],
      fileUrl: [null, [Validators.required, Validators.pattern(/^(https?:\/\/)?((localhost)|(\d{1,3}(\.\d{1,3}){3})|([a-zA-Z0-9.-]+))(:\d+)?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/)]],
      resolution: [null],
      colorSpace: [null],
      container: [null],
      aspectRatio: [null],
      frameRate: [null],
      audio: [null],
    });
  }

  getJSONToSaveMedia = () => {
    try {
      let mediaForm = this.mediaForm;
      console.log(mediaForm);
      if (mediaForm.get("title").value == "" || mediaForm.get("title").value == "undefined" || mediaForm.get("title").value == null) {
        this.toastr.warning("please add title.", "Media");
        return;
      }
      if (mediaForm.get("umid").value == "" || mediaForm.get("umid").value == "undefined" || mediaForm.get("umid").value == null) {
        this.toastr.warning("please Enter Unique Media Id.");
        return;
      }
      let mediaData = {
        id: this.mediaData && this.mediaData.id ? this.mediaData.id : null,
        mediaTitle: mediaForm.get("title").value || null,
        uMId: mediaForm.get("umid").value || null,
        mediaTypeId: mediaForm.get("type").value || null,
        mediaSupportId: mediaForm.get("support").value || null,
        formatId: mediaForm.get("format").value || null,
        mediaBitrateId: mediaForm.get("bitrate").value || null,
        status: mediaForm.get("status").value || null,
        sanStatus: mediaForm.get("sanstatus").value || null,
        language: mediaForm.get("language").value || null,
        mediaVersion: mediaForm.get("version").value || null,
        personId: mediaForm.get("person").value || null,
        assetId: this.assetId || null,
        vaultShelf: mediaForm.get("vaultshelf").value || null,
        vaultStatus: mediaForm.get("vaultstatus").value || null,
        barcodeId: mediaForm.get("barcode").value || null,
        barcodeUId: mediaForm.get("barcodeUId").value || null,
        barcodeUrl: this.barcodeUrl || null,
        resolution: mediaForm.get("resolution").value || null,
        colorSpace: mediaForm.get("colorSpace").value || null,
        fileType: mediaForm.get("fileType").value || null,
        fileUrl: mediaForm.get("fileUrl").value || null,
        aspectRatio: mediaForm.get("aspectRatio").value || null,
        frameRate: mediaForm.get("frameRate").value || null,
        audio: mediaForm.get("audio").value || null,
        date: mediaForm.get("date").value || null,
        duration: mediaForm.get("duration").value || null,
        removePhoto: this.removePhoto || null,
      };

      console.log(mediaData);

      return mediaData;
    } catch (err) {
      console.log(err);
    }
  };

  saveMedia() {
    if (!this.showMediaStep) {
      const shelf = this.mediaForm.get("vaultshelf")?.value;
      const status = this.mediaForm.get("vaultstatus")?.value;

      if (!shelf || !status) {
        this.toastr.warning("Please add vault shelf and vault status.", "Vault");
        return;
      }
    }
    this.blockedPanel = true;
    let body = this.getJSONToSaveMedia();
    console.log(body);
    this.httpService.callApi("saveOrUpdateMedia", { body: body }).subscribe(
      (response) => {
        this.toastr.success("Successfully Saved", "Media");
        this.uploadPicture(response.id);
        this.getMediaByAsset();
        this.toastr.success("Saved");
        this.closeModalEvent.emit(false);
        this.blockedPanel = false;
      },
      (error) => {
        this.toastr.warning(error.error.message, "Media");
        this.blockedPanel = false;
      }
    );
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "video/mp4", "audio/mp3"];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error("Invalid file type. Allowed: JPG, PNG, MP4, MP3");
        return;
      }

      this.mediaForm.patchValue({
        thumbnailFile: file,
      });
    }
  }

  setValidationOnDuration() {
    if (this.mediaForm) {
      this.mediaForm.get("duration").valueChanges.subscribe((value) => {
        let arr = value.split(":");
        let str = arr[0];
        let subStr = str.substr(0, 1);
        if (subStr == "2") this.mask = [/[0-2]/, /[0-3]/, ":", /[0-5]/, /[0-9]/];
        else this.mask = [/[0-2]/, /[0-9]/, ":", /[0-5]/, /[0-9]/];
      });
    }
  }

  /*-  To upload picture*/
  uploadPicture(personnelId: number) {
    console.log("this is avatar value", this.mediaForm.get("avatar").value);
    if (this.mediaForm.get("avatar").value) {
      let body = new FormData();
      body.append("discriminator", "Media");
      body.append("fileContent", this.mediaForm.get("avatar").value);
      body.append("extension", this.fileExtension);
      body.append("fileName", this.fileName);
      this.httpService.callApi("uploadPicture", { body: body, pathVariable: personnelId }).subscribe(
        (respone) => {},
        (error) => {}
      );
    }
  }

  onThumbnailChange(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileExtension = file.name.split(".").pop().toLowerCase();
      this.fileExtension = file.name.split(".").pop().toLowerCase();
      this.fileName = file.name.split(".")[0];
      if (this.isInArray(this.allowedExtensionsForThumbnail, fileExtension) && file.size < 2097152) {
        this.thumbnailName = file.name;
        this.addedThumbnailMessage = "Successfully added File: " + file.name;
        this.invalidThumbnailFormatError = null;
        this.mediaForm.get("avatar").setValue(file);

        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (event) => {
          let target: any = event.target;
          this.thumbnailUrl = target.result;
        };
      } else if (file.size > 2097152) {
        this.thumbnailName = null;
        this.addedThumbnailMessage = null;
        this.mediaForm.get("avatar").setValue(null);
        this.invalidThumbnailFormatError = "File size should not be greater than 2MB.";
      } else {
        this.thumbnailName = null;
        this.addedThumbnailMessage = null;
        this.mediaForm.get("avatar").setValue(null);
        this.invalidThumbnailFormatError = "Only jpeg, jpg, or png format allowed!!";
      }
    }
  }

  removeThumbnail(): void {
    this.mediaForm.get("avatar").setValue(null);
    this.thumbnailUrl = null;
    this.thumbnailName = "no file chosen";
    this.invalidThumbnailFormatError = "";
    this.removePhoto = true;
  }

  getMediaByAsset() {
    this.blockedPanel = true; // move this to before the API call
    this.httpService.callApi("getMediaListByAsset", { pathVariable: this.assetId }).subscribe((response) => {
      const enrichedData = response;

      this.mediaDetails = enrichedData;
      // Now hide the loader
      this.blockedPanel = false;
    });
  }
}
